import DocumentService from '@/Modules/Document/DocumentService.js'

export default class QuoteDocumentService extends DocumentService {
  static resource = 'quotes'
}
